import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { FC, useCallback, useEffect, useState } from 'react';
import 'react-pure-modal/dist/react-pure-modal.min.css';
import CircularProgress from '@mui/material/CircularProgress';
import Cancel from '@mui/icons-material/Cancel';
import CheckCircle from '@mui/icons-material/CheckCircle';
import CustomizedDialog from '../MUISpecifics/dialog/CustumizedDialog';
import { useTranslation } from 'react-i18next';

interface ConfirmModalProps {
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
  title?: string;
}

type SubmissionState = 'idle' | 'submitting';

const getIcon = (state: SubmissionState) => {
  switch (state) {
    case 'submitting':
      return <CircularProgress color="inherit" size={20} />;
    default:
      return <CheckCircle />;
  }
};

const ConfirmModal: FC<React.PropsWithChildren<ConfirmModalProps>> = ({
  onCancel,
  onConfirm,
  open,
  children,
  title = 'Confirmation',
}) => {

  // use translation here : 
  const { t } = useTranslation('commons');

  const [submissionState, setSubmissionState] =
    useState<SubmissionState>('idle');

  const handleConfirm = useCallback(() => {
    setSubmissionState('submitting');
    onConfirm();
    onCancel();
    setSubmissionState('idle');
  }, [onConfirm, onCancel, setSubmissionState]);

  const handleCancel = useCallback(() => {
    setSubmissionState('submitting');
    onCancel();
    setSubmissionState('idle');
  }, [onCancel, setSubmissionState]);

  useEffect(() => {
    const keyDownHandler = (ev: KeyboardEvent) => {
      if (ev.key === 'Enter') {
        ev.preventDefault();
        handleConfirm();
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [handleConfirm]);

  return (
    <CustomizedDialog 
      open={open} 
      onCancel={handleCancel}      
      title={title}>

      {children}
      <Stack 
        spacing={2}
        direction="row"
        alignItems="flex-end"
        justifyContent="center"
        component="form"  
        sx={{ marginTop: 5, }}
        noValidate             
        onSubmit={(e) => {
            e.preventDefault();
            handleConfirm();
          }}
        >
          <Button
              type="submit"
              variant="contained"
              startIcon={getIcon(submissionState)}
              disabled={submissionState === 'submitting'}
            >
              {submissionState === 'submitting' ? t('En cours') : t('Confirmer')}
            </Button>
            <Button
              variant="outlined"
              onClick={handleCancel}
              startIcon={<Cancel />}
              disabled={submissionState === 'submitting'}
            >
              {t('Annuler')}
            </Button>
      </Stack>      

    </CustomizedDialog>    
  );
};

export default ConfirmModal;
